import instance from './interceptor'
import Vue from 'vue';

function request(url, params, options = {
  loading: true,
  mock: false,
  error: true
}, method) {
  let loadingInstance;
  return new Promise((resolve, reject) => {
    let data = {}
    if (method == 'get') data = {
      params
    }
    if (method == 'post') data = {
      data: params
    }
    instance({
      url,
      method,
      ...data
    }).then((res) => {
      resolve(res);
    }).catch((error) => {
      resolve(error);
    }).finally(() => {
    })
  })
}

function get(url, params, options) {
  return request(Vue.prototype.api + url, params, options, 'get')
}
function post(url, params, options) {
  return request(Vue.prototype.api + url, params, options, 'post')
}
export default {
  get,
  post
}



// WEBPACK FOOTER //
// ./src/assets/js/axios/request.js